import React from 'react';

import styled from 'styled-components';

import { useCommunityAdminContext } from './CommunityAdminContextProvider';
import { COMMUNITY_CONTRACT_TYPE, CONTRACT_SLUG_PREFIX } from '../../../constants';
import BasicInfoEditForm from '../../CommunityInfo/general/basicInfo/BasicInfoEditForm';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  overflow: hidden;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  padding-top: 16px;
  padding-left: 30px;
`;

const CommunityAdminContentInfo = () => {
  const { form, loadingCommunity, community, handleConfirm } = useCommunityAdminContext();

  const communityRentalTypes = (community?.rental_types || []).map((type: any) => type.type);

  const communityLifePlanContracts = (community?.contracts || [])
    .filter((contract: any) => contract.type != COMMUNITY_CONTRACT_TYPE.RENTAL)
    .reduce((acc: Record<string, any[]>, contract: any) => {
      const key = `${CONTRACT_SLUG_PREFIX}-${contract.type}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push({
        id: contract?.id,
        type: contract.type,
        refund_percentage: contract.refund_percentage,
      });
      return acc;
    }, {});

  return (
    <Container>
      <Title>Community Info</Title>
      {!loadingCommunity && (
        <BasicInfoEditForm
          form={form}
          community={community}
          handleSubmit={handleConfirm}
          handleValuesChanged={() => {
            // Handle values changed logic here if needed
          }}
          initialValues={{
            community_id: community?.id,
            comunity_name: community?.comunity_name,
            address: community?.address,
            city: community?.city,
            state: community?.state,
            zip_code: community?.zip_code,
            phone_number: community?.phone_number,
            notes: community?.notes,
            website: community?.website,
            year_opened: community?.year_opened,
            google_map_location: community?.google_map_location,
            a_place_for_mom_id: community?.a_place_for_mom_id,
            caring_url: community?.caring_url,
            rental_types: communityRentalTypes,
            contracts: communityLifePlanContracts,
          }}
        />
      )}
    </Container>
  );
};

export default CommunityAdminContentInfo;
